module.exports = __webpack_public_path__ + "media/images/defaultbenefit-image-13f6930d.jpg";